<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.941"
    height="16.935"
    viewBox="0 0 16.941 16.935"
    fill="currentColor"
  >
    <g transform="translate(-1328 -21)">
      <g transform="translate(1328 21)">
        <g transform="translate(6.208 4.5)">
          <g transform="translate(6.215)">
            <path
              class="a"
              d="M99.82,43.867a.548.548,0,0,1-.4-.163.559.559,0,0,1,0-.8l2.991-2.991L99.419,36.92a.566.566,0,0,1,.8-.8l3.379,3.4a.559.559,0,0,1,0,.8l-3.392,3.392A.56.56,0,0,1,99.82,43.867Z"
              transform="translate(-99.25 -35.95)"
            />
          </g>
          <g transform="translate(0 3.411)">
            <path
              class="a"
              d="M59.2,64.326H50.163a.563.563,0,1,1,0-1.126H59.2a.563.563,0,1,1,0,1.126Z"
              transform="translate(-49.6 -63.2)"
            />
          </g>
        </g>
        <path
          class="a"
          d="M9.6,16.935H2.829A2.823,2.823,0,0,1,0,14.119V2.829A2.826,2.826,0,0,1,2.829,0H9.6a.563.563,0,1,1,0,1.127H2.829a1.7,1.7,0,0,0-1.7,1.7v11.29a1.691,1.691,0,0,0,1.69,1.69H9.588a.561.561,0,0,1,.563.563A.543.543,0,0,1,9.6,16.935Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LogoutIcon",
};
</script>

<style scoped>
svg {
  width: 17px;
  height: 17px;
}
</style>
